module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-center",
    staticStyle: {
      "background-color": "#f7f8fa"
    }
  }, [_c('div', {
    staticClass: "head clearfix",
    staticStyle: {
      "background": "url('./static/images/centerBg.png') center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/opera/huanqiuCenterInfo?redirect=/opera/centerHuanQiu"
    }
  }, [_c('div', {
    staticClass: "textImg"
  }, [_c('div', {
    staticClass: "pic"
  }, [(!!_vm.perInfo.pic) ? _c('img', {
    attrs: {
      "src": _vm.perInfo.pic
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/tx.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.perInfo.name))])]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-you"
  })])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "setOption"
  }, [(_vm.mihotelBinding) ? _c('mt-cell', {
    attrs: {
      "title": "楼栋绑定",
      "to": "/opera/bindBuildingHuanQiu",
      "is-link": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "日志查看",
      "to": "/opera/logRecordHuanQiu",
      "is-link": ""
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "版本信息",
      "to": "/opera/versionDetailHuanQiu",
      "is-link": ""
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "参数配置",
      "to": "/opera/settingHuanQiu",
      "is-link": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.loginOut
    }
  }, [_vm._v(_vm._s(_vm.$t('logout')))]), _vm._v(" "), _c('foot-nav', {
    attrs: {
      "sta": "3"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e8e68928","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/huanQiuPage/centerHuanQiu.vue
// module id = 1845
// module chunks = 107